import API from "./apiConfig";
import type { AxiosRequestConfig } from "axios";
import { handleError } from "../../utils/errorHandler";

export const apiUrl = import.meta.env.VITE_API_URL || "http://localhost:3000";

export const http = API;

type RequestDataHandledError = Error & {
  __handledByApiInterceptor?: boolean;
};

type ApiResponseEnvelope<T> = {
  success?: boolean;
  message?: string;
  data?: T;
};

const isHandledRequestError = (error: unknown) =>
  typeof error === "object" &&
  error !== null &&
  "__handledByApiInterceptor" in error &&
  error.__handledByApiInterceptor === true;

export function setAuthToken(token?: string | null) {
  if (token) localStorage.setItem("assetToken", token);
  else localStorage.removeItem("assetToken");
}

// Keep the default compatible with legacy consumers that omit a response type.
export async function requestData<T = any>(
  config: AxiosRequestConfig,
): Promise<T> {
  try {
    const resp = await API.request<T>(config);
    const body: unknown = resp.data;
    if (body && typeof body === "object") {
      const envelope = body as ApiResponseEnvelope<T>;
      if (envelope.success === false) {
        const error = new Error(
          envelope.message || "Request failed",
        ) as RequestDataHandledError;
        error.__handledByApiInterceptor = true;
        throw error;
      }

      if ("data" in envelope) return envelope.data as T;
    }

    return body as T;
  } catch (err: unknown) {
    if (!isHandledRequestError(err)) {
      handleError(err);
    }
    throw err;
  }
}

export default http;
